exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-info {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px; }\n\n.user-info__currency-block {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 8px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.15); }\n  .user-info__currency-block:last-child {\n    border-bottom: none; }\n  .user-info__currency-block span {\n    color: #000;\n    font-size: 15px;\n    line-height: 24px;\n    font-weight: 500; }\n", ""]);

// exports
